<template>
    <div class="vue-modal-wrapper">
        <button class="close-button mt-1" @click="handleClose">
            <span class="visually-hidden">{{ closeText }}</span>
        </button>

        <div class="content-wrapper text-center">
            <h2>{{ whoAreYouText }}</h2>
            
            <nav class="d-flex justify-content-center">
                <ul class="menu">
                    <li class="menu-item--active-trail">
                        <button @click="handleClose" class="is-active text-decoration-none">{{ vehicleOwnerText }}</button>
                    </li>
                    <li>
                        <button @click="handleClickRepairShop" class="text-decoration-none">{{ repairShopText }}</button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalWrapper",

    props: {
        garageUrl: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            userIsRepairShop: false,
            closeText: window.Drupal.t('Close'),
            whoAreYouText: window.Drupal.t('Who are you?'),
            vehicleOwnerText: window.Drupal.t('I am a Vehicle Owner'),
            repairShopText: window.Drupal.t('I am a Repair Shop')
        }
    },

    methods: {
        handleClose() {
            this.$modal.close();

            localStorage.setItem('repair-shop', '0')

            this.userIsRepairShop = false
        },

        handleClickRepairShop() {
            localStorage.setItem('repair-shop', '1')

            this.userIsRepairShop = true

            window.location.href = this.garageUrl
        }
    }
}
</script>